import type { ReactNode } from 'react';
import { useEmblaCarousel } from '@/components/Carousel/hooks/useEmblaCarousel';

type DraggableContainerProps = {
  children: (props: {
    isClickAllowed: (() => boolean) | undefined;
  }) => ReactNode;
};

export const DraggableContainer = ({ children }: DraggableContainerProps) => {
  const [tabListRef, embla] = useEmblaCarousel({
    containScroll: 'trimSnaps',
    dragFree: true,
  });

  return (
    <div
      ref={tabListRef}
      className="relative select-none overflow-x-scroll px-x2 scrollbar-hidden sm:px-x3 [&.is-dragging_*]:cursor-grabbing"
    >
      <div className="grid auto-cols-[clamp(170px,50%,220px)] grid-flow-col gap-x1">
        {children({ isClickAllowed: embla?.clickAllowed })}
      </div>
      <div className="pointer-events-none absolute inset-0 left-auto w-x3 bg-gradient-to-r from-transparent to-[--draggable-bg,var(--s-color-surface-1)]" />
      <div className="pointer-events-none absolute inset-0 right-auto w-x3 bg-gradient-to-r from-[--draggable-bg,var(--s-color-surface-1)] to-transparent" />
    </div>
  );
};

export const DraggableContainerLoading = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <div className="select-none overflow-x-hidden px-x2 scrollbar-hidden sm:px-x3">
      <div className="grid auto-cols-[clamp(170px,50%,220px)] grid-flow-col gap-x1">
        {children}
      </div>
      <div className="pointer-events-none absolute inset-0 left-auto w-x3 bg-gradient-to-r from-transparent to-[--draggable-bg,var(--s-color-surface-1)]" />
    </div>
  );
};
